"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _actions = require("../actions");

var _index = require("../../index");

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _AudienceProfiling = _interopRequireDefault(require("../components/AudienceProfiling"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WorkflowAudienceProfiling = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(WorkflowAudienceProfiling, _React$Component);

  function WorkflowAudienceProfiling() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = WorkflowAudienceProfiling.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        themesFor = _this$props.themesFor,
        setMediaShareOfAudience = _this$props.setMediaShareOfAudience,
        setShareOfAudience = _this$props.setShareOfAudience,
        theme = _this$props.theme,
        mediaTheme = _this$props.mediaTheme,
        profilingFilters = _this$props.profilingFilters,
        mediaFilters = _this$props.mediaFilters;
    var currentSetShareOfAudience, currentTheme, currentFilters;

    if (themesFor === 'media') {
      currentSetShareOfAudience = setMediaShareOfAudience;
      currentTheme = mediaTheme;
      currentFilters = mediaFilters;
    } else {
      currentSetShareOfAudience = setShareOfAudience;
      currentTheme = theme;
      currentFilters = profilingFilters;
    }

    return /*#__PURE__*/React.createElement(_AudienceProfiling["default"], _extends({}, this.props, {
      theme: currentTheme,
      filters: currentFilters,
      setShareOfAudience: currentSetShareOfAudience
    }));
  };

  return WorkflowAudienceProfiling;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    isFetchingGroupedPersona: state.groupedPersona.isFetching,
    superSegments: state.superSegments.bySlug,
    groupedPersonaRecords: state.groupedPersona.records,
    hasAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    theme: state.themeFilter.value,
    mediaTheme: state.mediaThemeFilter.value,
    profilingFilters: state.profilingFilters,
    mediaFilters: state.mediaFilters,
    audienceView: state.audienceView.view.value,
    isDataPage: state.options.isDataPage.value
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadGroupedPersona: _actions.loadGroupedPersona,
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess,
    loadProfileCategories: _actions.loadProfileCategories,
    setShareOfAudience: _actions.setShareOfAudience,
    setMediaShareOfAudience: _actions.setMediaShareOfAudience,
    resetDataPage: _actions.resetDataPage,
    setSelectedPersonas: _actions.setSelectedPersonas
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorkflowAudienceProfiling);

exports["default"] = _default;